import {styledByTheme} from '../../../../themes/architecture/styled-by-theme';
import {ListTitleTextDefaultBox} from './list-title-text.default.box';
import {ListTitleTextCasino777Box} from './list-title-text.casino777.box';
import {ListTitleTextCipBox} from "./list-title-text.cip.box";
import {ListTitleTextCisBox} from "./list-title-text.cis.box";
import {ListTitleTextSiBox} from "./list-title-text.si.box";
import {ListTitleTextMrGreenBox} from "./list-title-text.mrgreen.box";
import { ListTitleTextSICisBox } from './list-title-text.siCis.box';

export const ListTitleTextBox = styledByTheme(ListTitleTextDefaultBox)
    .forCip(ListTitleTextCipBox)
    .forWsopCip(ListTitleTextCipBox)
    .forCis(ListTitleTextCisBox)
    .forCasino777(ListTitleTextCasino777Box)
    .forSI(ListTitleTextSiBox)
    .forMrGreen(ListTitleTextMrGreenBox)
    .forSICis(ListTitleTextSICisBox)
    .apply();